import { render, staticRenderFns } from "./FlowNodeWidget.vue?vue&type=template&id=345cd454&scoped=true"
import script from "./FlowNodeWidget.vue?vue&type=script&lang=js"
export * from "./FlowNodeWidget.vue?vue&type=script&lang=js"
import style0 from "./FlowNodeWidget.vue?vue&type=style&index=0&id=345cd454&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345cd454",
  null
  
)

export default component.exports